/* eslint-disable no-unused-vars */
import clsx from 'clsx';
import PropTypes from 'prop-types';
import * as React from 'react';
import ApiGatewayIcon from '../../assets/svg/ApiGatewayIcon';
import DefaultIcon from '../../assets/svg/DefaultIcon';
import UserManagementIcon from '../../assets/svg/UserManagementIcon';

function ProjectCard(props) {
  const { onClick, title, icon, background, url, token, name, code } = props;

  return (
    <div
      className={clsx(
        'min-w-[155px] !rounded-lg',
        'max-h-[148px] max-w-[160px]',
        'break:max-h-[180px] break:max-w-[200px]',
      )}
      style={{ background: background || '#78909C' }}
    >
      {['UMP', 'CMP'].includes(code) ? (
        <div
          className='p-4 xs:p-6'
          onClick={() => {
            window.location.href = url;
          }}
          style={{ cursor: 'pointer' }}
        >
          <div
            className={clsx(
              'mb-3 flex items-center',
              'h-[46px] w-[43px]',
              'break:h-[60px] break:w-[50px]',
            )}
          >
            {code === 'UMP' ? <UserManagementIcon /> : icon}
          </div>
          <div className='!p-0 text-left'>
            <h5 className='text-base text-white'>{title.length ? title : name}</h5>
          </div>
        </div>
      ) : (
        <form action={url} method='post'>
          <input type='hidden' name='token' value={token} />
          <button className='h-full w-full p-4 xs:p-6' type='submit'>
            <div className='' onClick={onClick}>
              <div
                className={clsx(
                  'mb-3 flex items-center',
                  'h-[46px] w-[43px]',
                  'break:h-[60px] break:w-[50px]',
                )}
              >
                {code === 'AG' ? <ApiGatewayIcon /> : icon}
              </div>
              <div className='!p-0 text-left'>
                <h5 className='text-base text-white'>{title.length ? title : name}</h5>
              </div>
            </div>
          </button>
        </form>
      )}
    </div>
  );
}

ProjectCard.propTypes = {
  background: PropTypes.string,
  icon: PropTypes.element,
  title: PropTypes.string,
  name: PropTypes.string,
  code: PropTypes.string,
  onClick: PropTypes.func,
  url: PropTypes.string,
  token: PropTypes.string,
};

ProjectCard.defaultProps = {
  background: null,
  icon: <DefaultIcon />,
  title: '',
  name: '',
  onClick: () => {},
  url: '',
  code: '',
  token: '',
};

export default ProjectCard;
